import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { ActionType } from './annotation-tools.actions';
import svgElements from './svgs';
@Component({
    selector: 'app-annotation-tools',
    templateUrl: './annotation-tools.component.html',
    styleUrls: ['./annotation.component.scss'],
    standalone: false
})
export class AnnotationToolsComponent implements AfterViewInit {
  constructor(private _sanitizer: DomSanitizer) {}
  @Output() menuItemSelect = new EventEmitter();
  @Input() closeAllTrigger: Subject<any> = new Subject();

  ngAfterViewInit() {
    this.closeAllTrigger.subscribe(() => this.closeMenus());
  }

  _strokeWidth: number;
  get strokeWidth(): any {
    if (this.selectedElement) {
      return this.selectedElement.data.strokeWidth;
    }
    return this._strokeWidth;
  }
  @Input() set strokeWidth(value: any) {
    this._strokeWidth = value;
  }

  @Output() strokeWidthChange = new EventEmitter();
  @Input() availableStrokes = [2, 5, 10, 15];

  _selectedColor: any = 'rgb(0, 0, 255)';
  get selectedColor(): any {
    if (this.selectedElement) {
      return this.selectedElement.data.color;
    }
    return this._selectedColor;
  }
  @Input() set selectedColor(value: any) {
    this._selectedColor = value;
  }
  @Output() selectedColorChange = new EventEmitter();

  @Input() availableColors = [
    'rgb(255,255,255)',
    'rgb(0, 0, 255)',
    'rgb(164, 72, 255)',
    'rgb(255, 248, 72)',
    'rgb(80,190,63)'
  ];

  @Input() selectedElement: any = null;

  isShapeSubmenuActive = false;
  isStrokeSubmenuActive = false;
  isColorSubmenuActive = false;

  @Input() selectedAction: ActionType | null = null;
  @Output() selectedActionChange = new EventEmitter<ActionType | null>();

  @Input() numberingIndex = 1;
  activeShapeIcon = 'crop_din';

  isSvgElementMenuActive = false;
  @Input() svgElements = svgElements;

  //selectedSvgElement = null;
  _selectedSvgElement: any = 'rgb(184, 230, 255)';
  get selectedSvgElement(): any {
    return this._selectedSvgElement;
  }
  @Input() set selectedSvgElement(value: any) {
    this._selectedSvgElement = value;
  }
  @Output() selectedSvgElementChange = new EventEmitter();

  selectStroke(stroke) {
    this.strokeWidth = stroke;
    this.strokeWidthChange.emit(stroke);
  }

  selectColor(color) {
    this.selectedColor = color;
    this.selectedColorChange.emit(color);
  }

  selectSvgElement(event, svgElement) {
    event.stopPropagation();
    this.closeMenus();
    this.selectedSvgElement = svgElement;
    this.selectedSvgElementChange.emit(svgElement);
    this.selectAction(ActionType.svgElement);
  }

  selectShape(event, shape) {
    event.stopPropagation();
    this.closeMenus();
    switch (shape) {
      case 'rectangleShape':
        if (this.selectedAction !== ActionType.rectangle) {
          this.selectAction(ActionType.rectangle);
        }
        this.activeShapeIcon = 'crop_din';
        break;
      case 'circleShape':
        if (this.selectedAction !== ActionType.circle) {
          this.selectAction(ActionType.circle);
        }
        this.activeShapeIcon = 'circle';
        break;
      case 'ellipseShape':
        if (this.selectedAction !== ActionType.ellipse) {
          this.selectAction(ActionType.ellipse);
        }
        this.activeShapeIcon = 'circle';
        break;
    }
  }

  selectAction(action: ActionType) {
    if (this.selectedAction === action) {
      this.selectedAction = null;
      this.selectedActionChange.emit(null);
    } else {
      this.selectedAction = action;
      this.selectedActionChange.emit(action);
    }
  }

  public get selectedNumberingElement() {
    if (this.selectedElement && this.selectedElement.type === 'number') {
      return true;
    }
    return null;
  }
  closeMenus() {
    this.isShapeSubmenuActive = false;
    this.isColorSubmenuActive = false;
    this.isStrokeSubmenuActive = false;
    this.isSvgElementMenuActive = false;
  }

  onListItemClick(item: string, data: any = null) {
    let menuState;
    switch (item) {
      case 'zoomOut':
        this.closeMenus();
        this.selectAction(ActionType.zoomOut);
        break;
      case 'zoomIn':
        this.closeMenus();
        this.selectAction(ActionType.zoomIn);
        break;
      case 'stroke':
        this.menuItemSelect.emit(item);
        menuState = this.isStrokeSubmenuActive;
        this.closeMenus();
        this.isStrokeSubmenuActive = !menuState;

        break;
      case 'color':
        menuState = this.isColorSubmenuActive;
        this.menuItemSelect.emit(item);
        this.closeMenus();
        this.isColorSubmenuActive = !menuState;
        break;
      case 'svgElement':
        menuState = this.isSvgElementMenuActive;
        //this.menuItemSelect.emit(item);
        //this.selectAction(ActionType.svgElement);
        this.closeMenus();
        this.isSvgElementMenuActive = !menuState;
        break;

      case 'shape':
        /*if (this.selectedAction !== ActionType.rectangle && this.selectedAction !== ActionType.circle) {
          this.selectAction(ActionType.rectangle);
        }*/
        menuState = this.isShapeSubmenuActive;

        if (!menuState) {
          if (this.activeShapeIcon === 'circle') {
            this.selectAction(null);
            this.selectAction(ActionType.ellipse);
          } else {
            this.selectAction(null);
            this.selectAction(ActionType.rectangle);
          }
        } else {
          this.selectAction(null);
        }
        //this.menuItemSelect.emit(item);

        this.closeMenus();
        this.isShapeSubmenuActive = !menuState;
        break;
      case 'numbering':
        this.closeMenus();
        this.selectAction(ActionType.numbering);
        break;
      case 'freeHand':
        this.closeMenus();
        this.selectAction(ActionType.freeHand);
        break;
      case 'description':
        this.closeMenus();
        this.menuItemSelect.emit(item);
      default:
        this.closeMenus();
        this.menuItemSelect.emit(item);
        break;
    }
  }

  getSVGImageUrl(image) {
    let base64string = btoa(image);
    return this._sanitizer.bypassSecurityTrustResourceUrl(`data:image/svg+xml;base64,${base64string}`);
  }
}
